import { i18n } from '@shared/i18n';
import IdField from '@shared/fields/id-field';
import DateTimeRangeField from '@shared/fields/date-time-range-field';
import DateTimeField from '@shared/fields/date-time-field';
import { GenericModel } from '@shared/model/generic-model';
import StringField from '@shared/fields/string-field';
import EnumeratorField from '@shared/fields/enumerator-field';
import { UserField } from '@modules/auth/user-field';
import FilesField from '@shared/fields/files-field';

function label(name) {
  return i18n(`entities.news.fields.${name}`);
}

function enumeratorLabel(name, value) {
  return i18n(`entities.news.enumerators.${name}.${value}`);
}

const fields = {
  id: new IdField('id', label('id')),
  title: new StringField('title', label('title'), {
    "required": true
  }),
  subtitle: new StringField('subtitle', label('subtitle'), {
    "required": true
  }),
  contentHtml: new StringField('contentHtml', label('contentHtml'), {}),
  description: new StringField('description', label('description'), {
    "required": true
  }),
  sourceUrl: new StringField('sourceUrl', label('sourceUrl'), {}),
  media: new FilesField('media', label('media'), 'news/media',{
    "size": 10000000
  }),
  status: new EnumeratorField('status', label('status'), [
    { id: 'draft', label: enumeratorLabel('status', 'draft') },
    { id: 'published', label: enumeratorLabel('status', 'published') },
  ],{
    "required": true
  }),
  propertyOwner: UserField.relationToOne('propertyOwner', label('propertyOwner'), {}),
  createdAt: new DateTimeField(
    'createdAt',
    label('createdAt'),
  ),
  updatedAt: new DateTimeField(
    'updatedAt',
    label('updatedAt'),
  ),
  createdAtRange: new DateTimeRangeField(
    'createdAtRange',
    label('createdAtRange'),
  ),

};

export class NewsModel extends GenericModel {
  static get fields() {
    return fields;
  }
}
